module.exports = __webpack_public_path__ + "static/media/model-mission-4.2ddbd22c.png";